// TradeInteractor.js
import React, { useState, useEffect } from "react";
import { ethers } from "ethers";
import {
  Box,
  VStack,
  Input,
  Button,
  Text,
  Divider,
  HStack,
  Tag,
} from "@chakra-ui/react";

const TradeInteractor = ({ contractAddress, abi }) => {
  const [offerNfts, setOfferNfts] = useState("");
  const [offerNftIds, setOfferNftIds] = useState("");
  const [requestNfts, setRequestNfts] = useState("");
  const [openTrades, setOpenTrades] = useState([]);
  const [loading, setLoading] = useState(false);

  const MAX_TRADE_ID = 100; // Temporary static upper limit

  // Add more state variables as needed

  // Function to connect to Ethereum
  const connectWallet = async () => {
    if (window.ethereum) {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      await provider.send("eth_requestAccounts", []);
      const signer = provider.getSigner();
      return new ethers.Contract(contractAddress, abi, signer);
    } else {
      console.log("Ethereum object not found, install MetaMask.");
      return null;
    }
  };

  // Example function to open a trade
  const openTrade = async () => {
    const contract = await connectWallet();
    if (contract) {
      const offerNftsArray = offerNfts.split(",");
      const offerNftIdsArray = offerNftIds.split(",").map(Number);
      const requestNftsArray = requestNfts.split(",");

      await contract.openTrade(
        offerNftsArray,
        offerNftIdsArray,
        requestNftsArray
      );
      console.log("Trade opened");
      // Add any additional logic needed after opening the trade
    }
  };
  const fetchTradeOffers = async (tradeId, contract) => {
    try {
      const tradeDetails = await contract.getOffers(tradeId);
      console.log(`Trade Details for ID ${tradeId}:`, tradeDetails);
      return tradeDetails;
    } catch (error) {
      console.error("Error fetching trade offers:", error);
      // Handle the error appropriately
    }
  };

  const fetchOpenTrades = async () => {
    const contract = await connectWallet();
    if (contract) {
      setLoading(true);
      const trades = [];
      // You need to determine how to iterate over trade IDs
      for (let tradeId = 1; tradeId <= MAX_TRADE_ID; tradeId++) {
        const trade = await fetchTradeOffers(tradeId, contract);
        if (trade && trade.length >= 4 && trade[3]) {
          trades.push({ tradeId, trade });
        }
      }
      setOpenTrades(trades);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchOpenTrades();
  }, []);

  return (
    <VStack spacing={4}>
      <Box p={4} borderWidth="1px" borderRadius="lg">
        <VStack spacing={3}>
          <Input
            placeholder="Offer NFT Addresses (comma-separated)"
            value={offerNfts}
            onChange={(e) => setOfferNfts(e.target.value)}
          />
          <Input
            placeholder="Offer NFT IDs (comma-separated)"
            value={offerNftIds}
            onChange={(e) => setOfferNftIds(e.target.value)}
          />
          <Input
            placeholder="Request NFT Addresses (comma-separated)"
            value={requestNfts}
            onChange={(e) => setRequestNfts(e.target.value)}
          />
          <Button colorScheme="blue" onClick={openTrade}>
            Open Trade
          </Button>
        </VStack>
      </Box>
      <Box w="100%" p={4} borderWidth="1px" borderRadius="lg">
        {loading ? (
          <Text>Loading trades...</Text>
        ) : (
          openTrades.map(({ tradeId, trade }, index) => (
            <Box key={index} p={3} borderWidth="1px" borderRadius="lg" mb={3}>
              <Text fontWeight="bold">Trade ID: {tradeId}</Text>
              <HStack spacing={4}>
                <Tag colorScheme="blue">
                  Offered NFTs: {trade[0].join(", ")}
                </Tag>
                <Tag colorScheme="green">
                  Requested NFTs: {trade[2].join(", ")}
                </Tag>
              </HStack>
            </Box>
          ))
        )}
      </Box>
    </VStack>
  );
};

export default TradeInteractor;
